import $ from 'jquery'
import Blacklight from "../blacklight";
import setupMultiselects from '../multiselects'
import setupCombineFields from '../combine_fields'

function initializeNominateForm() {
    setupMultiselects('select.nomination-select')
    setupCombineFields()
}

Blacklight.onLoad(initializeNominateForm);
initializeNominateForm();
